import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/recommendations.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This is where things get even more subjective - essentially, `}<strong parentName="p">{`you should start working your way down the list from biggest sign-up bonus to smaller bonuses `}</strong>{`(while taking into account banks' application rules and sensitivity to inquiries/new accounts), which is both subjective and an ever-changing target. However, here's a good default list to follow; please tailor to your needs.`}</p>
    <p>{`To maximize your odds of approval, you'll want to spread applications around among banks over time (except where strategically combining HPs), and `}<strong parentName="p">{`respect banks' application rules`}</strong>{` (Amex's 2/90, Barclay's 6/24, Citi's 8/65 and 6/6, Chase's 2/30, BoA's 2/3/4, etc. `}<strong parentName="p">{`Check out the guide to banks' anti-churning rules here: `}<a parentName="strong" {...{
          "href": "http://redd.it/819r08/"
        }}>{`http://redd.it/819r08/`}</a></strong>{`):`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Barclays AA and Barclays JetBlue Plus (I'd try for a double-dip - apply first for whichever one you want more) and Barclays AA Biz - all now seem to be subject to 6/24, so I'd just try for all the Barclay cards you can as soon as you go over 5/24`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Possible BoA app-o-rama on the same day as the Barclays apps, if you can do all the minimum spends - Premium Rewards, Alaska Biz, and one of the Alaska Personal,  Asiana, or Virgin Atlantic. BoA approvals have become a bit of a black box to me, so I'd just try for 2 personal and 1 biz in the same day and see what sticks.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Citi AA Platinum if under 6 inquiries in past 6 months (6/6 seems to be a soft rule, but it applies to many)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`(8+ days later) CitiBusiness AA if under 6 inquiries in past 6 months and have 5+ yrs of credit history`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`(Barclays, US Bank, and Citi are usually more inquiry sensitive than other banks on this list - the order of the cards below this line is more flexible`}</strong>{`)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Targeted 100k Amex personal platinum offer (if you have no Amex cards at the moment)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Some Citi TY card if under 6 inquiries in past 6 months - hold out for a 50k+ TY point bonus. `}<strong parentName="p">{`Premier/Prestige seem to require 0 inquiries in past 6 months for approval right now for many people!`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`US Bank Leverage Card`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Amex Marriott Brilliant (don't go over 2/90 with Amex)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Amex Marriott Biz`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The Amex charge cards - Gold, BRG, Biz Plat, 25k Green, etc. (and personal Plat, if no 100k offer for you), and the other Plat flavors (Morgan Stanley, Schwab)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Amex Delta and Hilton cards`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`BoA app-o-rama once your HPs and new accounts are low, if not done early on`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Capital One Venture once your HPs/new accts are low`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`HSBC Cards (need a Premier Checking account with them - grab one when there's a \\$450+ sign-up bonus for the checking account)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`US Bank Altitude Reserve (`}<strong parentName="p">{`don't`}</strong>{` buy gift cards `}{`[not even retail GCs]`}{` on this card) - can probably only get it if you have 0 inquiries/new accounts in the past 6 months. `}<strong parentName="p"><u>{`Alternatively, if you're planning on staying under 5/24 indefinitely, you might want to get this card FIRST, even before any Chase cards!`}</u></strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Other cards - PNC, Radisson, Wyndham, etc., once you're eligible based on the bank's application rules`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`One-off CU credit cards with big bonuses - follow Doctor of Credit to stay informed`}</p>
      </li>
    </ol>
    <p>{`Best travel cards for ongoing/unbonused spend - pick your favorite currency:`}</p>
    <ol>
      <li parentName="ol">{`For MRs: Amex Blue Biz Plus`}</li>
      <li parentName="ol">{`For URs: Chase Freedom Unlimited (get by PCing CSP or CSR) or Chase Ink Unlimited`}</li>
      <li parentName="ol">{`For TYs: Citi DoubleCash (get by PCing Citi AA personal or Citi Premier)`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      